import client from './axios'

export type PollDiffQuestionPathSegment = {
  id: number
  type: 'category' | 'group' | 'question'
  name: string
}

export type PollDiffQuestion = {
  id: number
  name: string
  description: string | null
}

export type PollDiffQuestionWithPath = PollDiffQuestion & {
  path: PollDiffQuestionPathSegment[]
}

export type PollDiffUpdatedQuestion = PollDiffQuestionWithPath & {
  previous: PollDiffQuestion
}

export type PollDiff = {
  poll: { id: number; name: string }
  prev_poll: { id: number; name: string }
  new_questions: PollDiffQuestionWithPath[]
  deleted_questions: PollDiffQuestionWithPath[]
  updated_questions: PollDiffUpdatedQuestion[]
}

export async function getPollDiff(pollId: number): Promise<PollDiff> {
  const { data } = await client.get<PollDiff>(`/poll/${pollId}/diff`)

  return data
}
